export default {
    '110000': {l: 'Z1', n: '北京', c: '110000', p: '86'},
    '120000': {l: 'Z1', n: '天津', c: '120000', p: '86'},
    '130000': {l: 'H', n: '河北', c: '130000', p: '86'},
    '140000': {l: 'S', n: '山西', c: '140000', p: '86'},
    '150000': {l: 'N', n: '内蒙古', c: '150000', p: '86'},
    '210000': {l: 'L', n: '辽宁', c: '210000', p: '86'},
    '220000': {l: 'J', n: '吉林', c: '220000', p: '86'},
    '230000': {l: 'H', n: '黑龙江', c: '230000', p: '86'},
    '310000': {l: 'Z1', n: '上海', c: '310000', p: '86'},
    '320000': {l: 'J', n: '江苏', c: '320000', p: '86'},
    '330000': {l: 'Z', n: '浙江', c: '330000', p: '86'},
    '340000': {l: 'A', n: '安徽', c: '340000', p: '86'},
    '350000': {l: 'F', n: '福建', c: '350000', p: '86'},
    '360000': {l: 'J', n: '江西', c: '360000', p: '86'},
    '370000': {l: 'S', n: '山东', c: '370000', p: '86'},
    '410000': {l: 'H', n: '河南', c: '410000', p: '86'},
    '420000': {l: 'H', n: '湖北', c: '420000', p: '86'},
    '430000': {l: 'H', n: '湖南', c: '430000', p: '86'},
    '440000': {l: 'G', n: '广东', c: '440000', p: '86'},
    '450000': {l: 'G', n: '广西', c: '450000', p: '86'},
    '460000': {l: 'H', n: '海南', c: '460000', p: '86'},
    '500000': {l: 'Z1', n: '重庆', c: '500000', p: '86'},
    '510000': {l: 'S', n: '四川', c: '510000', p: '86'},
    '520000': {l: 'G', n: '贵州', c: '520000', p: '86'},
    '530000': {l: 'Y', n: '云南', c: '530000', p: '86'},
    '540000': {l: 'X', n: '西藏', c: '540000', p: '86'},
    '610000': {l: 'S', n: '陕西', c: '610000', p: '86'},
    '620000': {l: 'G', n: '甘肃', c: '620000', p: '86'},
    '630000': {l: 'Q', n: '青海', c: '630000', p: '86'},
    '640000': {l: 'N', n: '宁夏', c: '640000', p: '86'},
    '650000': {l: 'X', n: '新疆', c: '650000', p: '86'},
    '710000': {l: 'T', n: '台湾', c: '710000', p: '86'},
    '810000': {l: 'Z2', n: '香港', c: '810000', p: '86'},
    '820000': {l: 'Z2', n: '澳门', c: '820000', p: '86'}
};


// WEBPACK FOOTER //
// ./src/components/city/province.js